export const isInternalURL = (url) => {
  const regex = /^(?:https?:\/\/)?(?:www.axios.com)(?:\/.*-|\/)(?:([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})|([0-9]+))(?:\.html){1}/i;
  return url.match(regex);
};

export const isStoryIdentifier = (url) => {
  const regex = /(?:^|-)(?:([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})|([0-9]+))(?:\.html){1}/i;
  return url.match(regex);
};



// WEBPACK FOOTER //
// ./src/utils/utils.js